import React from 'react';

import { useCompatGuard } from '../hooks/useCompatGuard';

export default function CompatBanner() {
  const { ok, info } = useCompatGuard();
  if (ok) return null;
  return (
    <div
      style={{
        background: '#b91c1c',
        color: 'white',
        padding: '8px',
        textAlign: 'center',
        zIndex: 9999,
      }}
    >
      Compatibility issue detected. Required API/schema not met. Current: API {info?.api} / Schema{' '}
      {info?.schema}
    </div>
  );
}
